import React from 'react'
import { Route } from 'react-router-dom'
import { UserRole } from '../types/userRoles'
import ProtectedRoute from '../routes/ProtectedRoute'
import { MenuItem } from '../types/menuItem.types'
import { Route as RouteConfig } from '../types/route.types'
import ManagerPageTemplate from '../components/ManagerPageTemplate/ManagerPageTemplate'
import CustomerPageTemplate from '../components/CustomerPageTemplate/CustomerPageTemplate'
import { PlanLevel } from '../features/Configuration/GeneralConfiguration/types/types'

export const generateProtectedRoutes = (routes: RouteConfig[], allowedRoles: UserRole[], menuItems: MenuItem[], pricingPlan?: PlanLevel) => {
  const filteredMenuItems = menuItems.filter((item) => !item.requiredPlan || (pricingPlan !== undefined && item.requiredPlan <= pricingPlan))

  return routes
    .map((route) => {
      if (route?.requiredPlan && pricingPlan !== undefined && route?.requiredPlan > pricingPlan) {
        return null
      }

      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ManagerPageTemplate menuItems={filteredMenuItems}>
              <ProtectedRoute allowedRoles={allowedRoles}>{route.element as React.ReactElement}</ProtectedRoute>
            </ManagerPageTemplate>
          }
        />
      )
    })
    .filter(Boolean) // Remove null values from the array
}

export const generateCustomerRoutes = (routes: RouteConfig[]) => {
  return routes.map((route) => (
    <Route key={route.path} path={route.path} element={<CustomerPageTemplate>{route.element as React.ReactElement}</CustomerPageTemplate>} />
  ))
}
